// Aggregated vanilla CSS for src/components/* — injected ONCE in App.tsx
// (mirrors library/styles/libraryStyles.ts). As each component is migrated off
// Tailwind, append its classes here under a unique registered prefix.
import { tourStyles } from "../common/tour/tourStyles";
import { tourLauncherStyles } from "../common/tour/tourLauncherStyles";
import { tourHelpButtonStyles } from "../common/tour/tourHelpButtonStyles";
import { aiDiagramStyles } from "../common/diagram/aiDiagramStyles";
import { liveCountdownStyles } from "../common/LiveCountdownStyles";
import { outcomeCardBodyStyles } from "../learner/learning-path/OutcomeCardBodyStyles";
import { assignmentKindChipStyles } from "../learner/assignments/AssignmentKindChipStyles";
import { vocabularyCardDeckStyles } from "../learner/vocabulary/VocabularyCardDeckStyles";

export const componentStyles = `
  /* ScreenCard (sc-) — bgColor/opacity remain caller-supplied props */
  .sc-card {
    min-height: 100%;
    border-radius: var(--rad-catchup-xlarge);
    width: 100%;
    border-color: var(--catchup-gray-50);
    background-color: var(--catchup-white);
  }
  .sc-opacity-default { opacity: 1; }
  .sc-fullscreen { box-shadow: var(--shadow-full-card); }
  .sc-windowed { border-width: 1px; border-style: solid; box-shadow: var(--shadow-card); }
  .sc-body {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    padding: 1.5rem;
  }

  /* ScoreRing (sr-) */
  .sr-wrap { position: relative; display: inline-flex; align-items: center; justify-content: center; }
  .sr-label { position: absolute; font-weight: 700; font-variant-numeric: tabular-nums; }
  .sr-txt-green { color: var(--catchup-hover-green); }
  .sr-txt-orange { color: #b4552f; }
  /* The ring STROKE stays the bright semantic colour, but the same hue as 12px text on a light
     card is unreadable (--catchup-red #ff6b6b is ~2.6:1 on white, well under AA's 4.5:1). The
     label gets a darkened tone of the same hue so a "0.0%" is legible on white AND on the sand
     prerequisite card. */
  .sr-txt-red { color: #c4402f; }

  /* StorageUtilization PDF pager + image helpers (stu-). w-catchup-table-header-item
     was a dead token (not in app-web config) → omitted. */
  .stu-pager {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
  }
  .stu-pg-btn { padding: 0.25rem 0.5rem; background-color: var(--catchup-blue-100); border-radius: var(--rad-catchup-small); }
  .stu-pg-count { font-size: var(--fs-md); }
  .stu-img { border-radius: var(--rad-catchup-xlarge); }
  .stu-img-full { width: 100%; }

  /* PassageActivityContext — context-based reading-passage card (pac-) */
  .pac-wrap { margin-bottom: 1rem; }
  /* V4: the passage is surface-less — the OKUMA METNİ badge head + plain
     relaxed text flow directly on the white solve card (no tinted box). */
  .pac-card {
    position: relative;
    margin-bottom: var(--space-4);
  }
  .pac-head {
    position: relative;
    display: flex; align-items: center; gap: var(--space-3);
    margin-bottom: var(--space-3);
  }
  .pac-head-ic {
    display: flex; align-items: center; justify-content: center;
    width: 36px; height: 36px; flex-shrink: 0;
    border-radius: var(--rad-catchup-medium);
    background: var(--brand-50);
    color: var(--brand-dark);
    box-shadow: inset 0 1px 1px rgba(255,255,255,0.8), 0 2px 6px -2px rgba(15,72,89,0.2);
  }
  .pac-head-title {
    font-size: var(--fs-md);
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--brand-dark);
  }
  .pac-body { position: relative; }

  /* Points wallet pill (pbd-) — shared by the contest + market heroes. Sits on a
     teal hero, so translucent-white glass + gold amount; the money bag is bumped
     larger than the label text. */
  .pbd-pill {
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 46px;
    padding: 0 20px;
    border-radius: var(--rad-catchup-full);
    background: rgba(255, 255, 255, 0.2);
    border: 1.5px solid rgba(255, 255, 255, 0.55);
    color: #fff;
    font-weight: 600;
    font-size: var(--fs-md);
    white-space: nowrap;
  }
  .pbd-ic { font-size: var(--fs-2xl); line-height: 1; }
  .pbd-val { color: #ffe9a8; font-size: var(--fs-lg); font-weight: 700; }
  .pbd-lbl { color: #fff; }

  /* LearnerApp root wrapper (xap-) */
  .xap-fill { height: 100%; position: relative; }

  /* ActivityPreviewById wrapper (apv-) */
  .apv-wrap { padding-left: 1.25rem; padding-right: 1.25rem; }

  /* RightsReserved (rr-) */
  .rr-wrap { display: flex; flex-direction: column; justify-content: center; align-items: center; }
  .rr-text { color: var(--catchup-gray-200); font-size: var(--fs-md); }
  .rr-link {
    cursor: pointer;
    font-size: var(--fs-md);
    color: var(--catchup-blue-500);
    text-decoration: underline;
  }
  .rr-link a { color: inherit; }

  ${tourStyles}
  ${tourLauncherStyles}
  ${tourHelpButtonStyles}
  ${aiDiagramStyles}
  ${liveCountdownStyles}
  ${outcomeCardBodyStyles}
  ${assignmentKindChipStyles}
  ${vocabularyCardDeckStyles}
`;
